import "./pokeballSpinner.css";
export const PokeballSpinner = () => {
	return (
		<div className="background">
			<div className="ball">
				<div className="mid-line">
					<div className="button-back">
						<div className="button-front"></div>
					</div>
				</div>
			</div>
		</div>
	);
};
